import { render, staticRenderFns } from "./integral-record.vue?vue&type=template&id=c70e7e34&scoped=true&"
import script from "./integral-record.vue?vue&type=script&lang=js&"
export * from "./integral-record.vue?vue&type=script&lang=js&"
import style0 from "./integral-record.vue?vue&type=style&index=0&id=c70e7e34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70e7e34",
  null
  
)

export default component.exports